<div class="agpr-agentDashboard">
    <agpr-scroll-panel id="agentDashboard.scroll" class="agpr-agentDashboard-scroll">
        <div class="agpr-agentDashboard-content">
            <agpr-date-query-popup
                id="agentDashboard.range"
                class="agpr-agentDashboard-rangePicker"
                [options]="rangeOptions"
                [hideDateTypeSelection]="true"
                [(ngModel)]="selectedRange"
                (ngModelChange)="rangeSelected($event)"
            ></agpr-date-query-popup>

            <div class="agpr-agentDashboard-summary">
                <!-- Not a metric, so it is not a card chart: a timestamp with no trend to report -->

                <div class="agpr-agentDashboard-activityCard">
                    <h4 class="agpr-agentDashboard-activityTitle">
                        {{ 'AutomationAgents.agent.dashboard.lastActivity' | localize }}
                    </h4>
                    <p class="agpr-agentDashboard-activityValue">
                        @if (lastCurationActivity) {
                            {{ lastCurationActivity | changeTimeZone: (userTimeZone$ | async) : dateFormat }}
                        } @else {
                            {{ 'AutomationAgents.notAvailable' | localize }}
                        }
                    </p>
                </div>


                <agpr-card-chart
                    class="agpr-agentDashboard-card"
                    [series]="analyzedSeries"
                    [color]="cardColors.volume"
                    [bubbleTooltipSubjectLocalizationString]="metricTooltipPrefix"
                    bubbleTooltipMetric="analyzed"
                    headingLevel="4"
                ></agpr-card-chart>

                <!-- Analyzed feeds curated, which the arrow between them says -->
                <span class="agpr-agentDashboard-flow fa-solid fa-arrow-right" aria-hidden="true"></span>

                <agpr-card-chart
                    class="agpr-agentDashboard-card"
                    [series]="curatedSeries"
                    [color]="cardColors.impressions"
                    [bubbleTooltipSubjectLocalizationString]="metricTooltipPrefix"
                    bubbleTooltipMetric="curated"
                    headingLevel="4"
                ></agpr-card-chart>

                <agpr-card-chart
                    class="agpr-agentDashboard-card"
                    [series]="curationRateSeries"
                    [color]="cardColors.engagements"
                    [isPercentage]="true"
                    percentageFormat="1.0-2"
                    [bubbleTooltipSubjectLocalizationString]="metricTooltipPrefix"
                    bubbleTooltipMetric="curationRate"
                    headingLevel="4"
                ></agpr-card-chart>
            </div>

            <section class="agpr-agentDashboard-activity">
                <h3 class="agpr-agentDashboard-activityHeading">
                    {{ 'AutomationAgents.agent.dashboard.activity' | localize }}
                </h3>
                <div class="agpr-agentDashboard-activityChart">
                    <agpr-am5-chart [series]="recentActivitySeries" [chart]="recentActivityChart"></agpr-am5-chart>
                </div>
            </section>

            <section class="agpr-agentDashboard-sourceSummary">
                <h3 class="agpr-agentDashboard-sourceHeading">
                    <span>{{ 'AutomationAgents.agent.dashboard.summaryBySource' | localize }}</span>
                    <agpr-dropdown
                        id="agentDashboard.source"
                        class="agpr-agentDashboard-sourcePicker"
                        [style]="dropdownTypes.borderless"
                        [options]="sourceOptions"
                        [bindToValue]="true"
                        [ngModel]="selectedSourceId"
                        (ngModelChange)="sourceSelected($event)"
                        [ariaLabel]="'AutomationAgents.agent.dashboard.summaryBySource' | localize"
                    ></agpr-dropdown>
                </h3>

                <div class="agpr-agentDashboard-sourceBody">
                    <div class="agpr-agentDashboard-sourceCards">
                        <agpr-card-chart
                            [series]="sourceAnalyzedSeries"
                            [color]="cardColors.volume"
                            [layout]="cardLayouts.vertical"
                            [bubbleTooltipSubjectLocalizationString]="metricTooltipPrefix"
                            bubbleTooltipMetric="analyzed"
                            headingLevel="4"
                        ></agpr-card-chart>
                        <agpr-card-chart
                            [series]="sourceCuratedSeries"
                            [color]="cardColors.impressions"
                            [layout]="cardLayouts.vertical"
                            [bubbleTooltipSubjectLocalizationString]="metricTooltipPrefix"
                            bubbleTooltipMetric="curated"
                            headingLevel="4"
                        ></agpr-card-chart>
                        <agpr-card-chart
                            [series]="sourceRateSeries"
                            [color]="cardColors.engagements"
                            [layout]="cardLayouts.vertical"
                            [isPercentage]="true"
                            percentageFormat="1.0-2"
                            [bubbleTooltipSubjectLocalizationString]="metricTooltipPrefix"
                            bubbleTooltipMetric="curationRate"
                            headingLevel="4"
                        ></agpr-card-chart>
                    </div>

                    <div class="agpr-agentDashboard-sourceChart">
                        <agpr-am5-chart [series]="sourceTrendSeries" [chart]="sourceTrendChart"></agpr-am5-chart>
                    </div>
                </div>
            </section>

            <div class="agpr-agentDashboard-tables">
                <section class="agpr-agentDashboard-table">
                    <div class="agpr-agentDashboard-tableHeader">
                        <h3 class="agpr-agentDashboard-tableHeading">
                            {{ 'AutomationAgents.agent.dashboard.liveSources' | localize }}
                        </h3>
                        <agpr-button
                            id="agentDashboard.addSource"
                            [style]="buttonTypes.icon"
                            icon="fa-regular fa-duotone fa-square-plus"
                            tooltip="AutomationAgents.agent.addSource"
                            tooltipPosition="left"
                            [ariaLabel]="'AutomationAgents.agent.addSource' | localize"
                            (click)="addSource()"
                        ></agpr-button>
                    </div>

                    <div class="agpr-agentDashboard-tableRow agpr-agentDashboard-tableRow--head">
                        <span>{{ 'AutomationAgents.card.column.status' | localize }}</span>
                        <span>{{ 'AutomationAgents.card.column.source' | localize }}</span>
                        <span class="agpr-agentDashboard-tableActivity">
                            {{ 'AutomationAgents.agent.dashboard.activityColumn' | localize }}
                        </span>
                        <span></span>
                    </div>

                    <ul class="agpr-agentDashboard-tableList">
                        @for (source of liveSources; track source.id; let i = $index; let last = $last) {
                            <li class="agpr-agentDashboard-tableRow agpr-contextMenu-parent">
                                <agpr-social-switch
                                    [id]="'agentDashboard_source_' + i + '_status'"
                                    class="agpr-agentDashboard-sourceStatus"
                                    [ngClass]="{
                                        'agpr-agentDashboard-sourceStatus--active': source.isActive,
                                        'agpr-agentDashboard-sourceStatus--error': source.hasError,
                                        'agpr-agentDashboard-sourceStatus--standby': source.isStandby
                                    }"
                                    [onText]="'AutomationAgents.card.source.active'"
                                    [tooltip]="source.isStandby ? 'AutomationAgents.card.source.standby.tooltip' : null"
                                    [offText]="`AutomationAgents.card.source.${source.status}`"
                                    [initiallyFocusable]="false"
                                    [ngModel]="source.isActive || source.isStandby"
                                    (ngModelChange)="statusChanged(source, $event)"
                                ></agpr-social-switch>

                                <span class="agpr-agentDashboard-tableName">
                                    <span class="agpr-agentDashboard-tableIcon" [ngClass]="sourceTypeIcons[source.dataSource?.type]" [agprTooltip]="sourceTypeLabels[source.dataSource?.type] ?? ''"></span>
                                    @if (source.dataSource?.type === sourceType.socialTopic) {
                                        {{ sourceLabel(source) }}
                                    } @else {
                                        <a
                                            [id]="'agentDashboard_source_' + i + '_view'"
                                            class="agpr-agentDashboard-tableLink"
                                            (click)="viewSource(source)"
                                            tabindex="0"
                                            [agprTooltip]="'View ' + sourceLabel(source)"
                                        >{{ sourceLabel(source) }}</a>
                                    }
                                </span>

                                <span class="agpr-agentDashboard-tableActivity">{{ sourceActivity(source) }}</span>

                                <agpr-split-button
                                    class="agpr-contextMenu"
                                    [id]="'agentDashboard_source_' + i + '_actions'"
                                    [style]="buttonTypes.icon"
                                    [showTriggerIcon]="false"
                                    icon="fa-light fa-ellipsis-vertical"
                                    [options]="rowOptions(source)"
                                    [data]="source"
                                    panelPositionX="right"
                                    [panelPositionY]="last ? 'top' : 'bottom'"
                                ></agpr-split-button>
                            </li>
                        }
                    </ul>
                </section>

                <section class="agpr-agentDashboard-table">
                    <div class="agpr-agentDashboard-tableHeader">
                        <h3 class="agpr-agentDashboard-tableHeading">
                            {{ 'AutomationAgents.agent.dashboard.adHocHistory' | localize }}
                        </h3>
                        <div class="agpr-agentDashboard-tableHeaderControls">
                            <agpr-button
                                id="agentDashboard.adHocSettings"
                                [style]="buttonTypes.icon"
                                icon="fa-regular fa-duotone fa-gear"
                                tooltip="AutomationAgents.agent.dashboard.adHocSettings"
                                tooltipPosition="left"
                                [ariaLabel]="'AutomationAgents.agent.dashboard.adHocSettings' | localize"
                                (click)="openAdHocSettings()"
                            ></agpr-button>
                            <agpr-button
                                id="agentDashboard.addAdHoc"
                                [style]="buttonTypes.icon"
                                icon="fa-regular fa-duotone fa-square-plus"
                                tooltip="AutomationAgents.agent.dashboard.addAdHoc"
                                tooltipPosition="left"
                                [ariaLabel]="'AutomationAgents.agent.dashboard.addAdHoc' | localize"
                                (click)="addAdHocCuration()"
                            ></agpr-button>
                        </div>
                    </div>

                    <div class="agpr-agentDashboard-tableRow agpr-agentDashboard-tableRow--adHoc agpr-agentDashboard-tableRow--head">
                        <span>{{ 'AutomationAgents.agent.dashboard.dateColumn' | localize }}</span>
                        <span>{{ 'AutomationAgents.card.column.source' | localize }}</span>
                        <span class="agpr-agentDashboard-tableActivity">
                            {{ 'AutomationAgents.agent.dashboard.activityColumn' | localize }}
                        </span>
                        <span></span>
                    </div>

                    @if (adHocHistory.length) {
                        <ul class="agpr-agentDashboard-tableList">
                            @for (entry of adHocHistory; track entry.run.id; let i = $index) {
                                <li class="agpr-agentDashboard-tableRow agpr-agentDashboard-tableRow--adHoc agpr-contextMenu-parent">
                                    <span>{{ entry.date | changeTimeZone: (userTimeZone$ | async) : dateFormat }}</span>
                                    <!-- Opens what the run covered, as the row's View source does. A
                                         run submitted from a query or a list of mentions has no
                                         source to open, so it reads as plain text -->
                                    @if (canViewAdHocSource(entry)) {
                                        <button
                                            [id]="'agentDashboard_adHoc_' + i + '_view'"
                                            class="agpr-agentDashboard-tableLink"
                                            [agprTooltip]="'AutomationAgents.card.source.view' | localize"
                                            tooltipPosition="top"
                                            (click)="viewAdHocSource(entry)"
                                        >{{ adHocSourceLabel(entry) }}</button>
                                    } @else {
                                        <span>{{ adHocSourceLabel(entry) }}</span>
                                    }
                                    <!-- A run still working has nothing settled to report yet -->
                                    <span class="agpr-agentDashboard-tableActivity">
                                        @if (entry.inProgress) {
                                            {{ 'AutomationAgents.adHoc.inProgress' | localize }}
                                        } @else {
                                            {{ entry.curated }}/{{ entry.analyzed }}
                                        }
                                    </span>

                                    <agpr-split-button
                                        class="agpr-contextMenu"
                                        [id]="'agentDashboard_adHoc_' + i + '_actions'"
                                        [style]="buttonTypes.icon"
                                        [showTriggerIcon]="false"
                                        icon="fa-light fa-ellipsis-vertical"
                                        [options]="adHocMenus.get(entry.run.id)"
                                        [data]="entry"
                                        panelPositionX="right"
                                    ></agpr-split-button>
                                </li>
                            }
                        </ul>
                    } @else {
                        <agpr-message
                            class="agpr-agentDashboard-tableEmpty"
                            [id]="'agentDashboard.adHocHistory.empty'"
                            [severity]="messageSeverity.noContent"
                            [bottomMargin]="false"
                            [useWhiteBg]="true"
                        >
                            {{ 'AutomationAgents.agent.dashboard.adHocHistory.empty' | localize }}
                        </agpr-message>
                    }
                </section>
            </div>
        </div>
    </agpr-scroll-panel>

    <!-- Everything above reports over one window, so one button re-reads the lot -->
    <agpr-action-bar>
        <ng-template #left>
            <agpr-button
                id="agentDashboard.refresh"
                label="Monitoring.result.refresh"
                [style]="buttonTypes.secondary"
                [loading]="refreshing"
                (click)="refresh()"
            ></agpr-button>
        </ng-template>
    </agpr-action-bar>
</div>
